import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { IFetchResponse } from "@preveil-api";
// Important: store must be imported before any src/common imports to eliminate circular dependencies
// eslint-disable-next-line import/order
import { store } from "./store/configureStore";
import { getAppConfiguration, AppConfiguration, GlobalErrorMessages, ServerConfiguration } from "src/common";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-datepicker/dist/react-datepicker.css";
import "react-tooltip/dist/react-tooltip.css";
import "./assets/scss/main.scss";

const startApp = async () => {
    // NOTE: Set Config default setting to .env (undefined) when in error fetching server config
    const response = await getAppConfiguration() as IFetchResponse<ServerConfiguration>;
    response.isError && console.info(GlobalErrorMessages.error_fetching_server_config);
    const config = new AppConfiguration((!response.isError) ? response.data : undefined);

    //  NOTE: Render Root and Provider with App after config was fetched
    const root_element = document.getElementById("root");
    if (!root_element) throw new Error("Failed to find the root element");
    const root = createRoot(root_element);
    root.render(
        <Provider store={store}>
            <App config={config} />
        </Provider>
    );


    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();

    // NOTE: Register the PDF viewer SW and immediately call update() so the browser re-fetches
    //   the SW file on every app load. Combined with skipWaiting() + clients.claim() inside the SW,
    //   this ensures users always get the latest SW version without needing to manually clear cache
    //   or close tabs — critical for production deployments where the SW CSP may change.
    if (AppConfiguration.buildForWeb() && "serviceWorker" in navigator) {
        navigator.serviceWorker
            .register("/pdf-viewer-sw.js", { scope: "/" })
            .then((registration) => registration.update())
            .catch((err) => console.error("PDF viewer SW registration failed:", err));
    }
};

startApp();
